import React from 'react';
import FunFact from '../../FunFact';

// Standard section background (matches theme $bodyBg / $surfaceDark)
const STANDARD_BG = '#111827';
// Same as home Hero overlay so bg image is visible in the back
const HERO_STYLE_OVERLAY = 'linear-gradient(135deg, rgba(3, 16, 30, 0.92) 0%, rgba(10, 15, 26, 0.85) 100%)';

export default function FunFactSection({ bgUrl, data }) {
  const wrapStyle = bgUrl
    ? {
        backgroundImage: `${HERO_STYLE_OVERLAY}, url(${bgUrl})`,
        backgroundColor: STANDARD_BG,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }
    : {
        backgroundColor: STANDARD_BG,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };

  return (
    <div className="container">
      <div
        className="cs_funfact_1_wrap cs_radius_30"
        style={wrapStyle}
      >
        {data?.map((item, index) => (
          <FunFact key={index} {...item} />
        ))}
      </div>
    </div>
  );
}
